import React from 'react';
import {withRouter, Link} from 'react-router-dom';
import {connect} from "react-redux";
import {Home as HomeIcon, User as AccountIcon, ShoppingBag as CartIcon, Command as AdminIcon} from 'react-feather';
import {primary, secondary} from 'styles/colors';
import {getUserRoles} from 'services/user';

class Footer extends React.Component {
    constructor(props) {
        super(props);
    }

    handleIcon(name, here) {
        const active = {color: primary, fill: `${primary}25`, 'stroke-width': 1, size: 21};
        const deActive = {color: secondary, fill: `${secondary}25`, 'stroke-width': 1, size: 21};

        const status = name == here ? active : deActive;

        switch (name) {
            case 'home':
                return <HomeIcon {...status}/>
            case 'cart':
                return <CartIcon {...status}/>
            case 'account':
                return <AccountIcon {...status}/>
            case 'admin':
                return <AdminIcon {...status}/>
        }
    }

    handleActive(loc) {
        if (loc.includes('admin'))
            return 'admin';
        if (loc.split('/').pop().toLowerCase() == 'account')
            return 'account';

        return 'home';
    };

    handleRoles = () => {
        const userRoles = getUserRoles();
        const isAdmin = userRoles && userRoles.includes('Admins');
        return isAdmin;
    };

    render() {
        const {location, match, locale} = this.props;
        const here = this.handleActive(location.pathname);

        const pageTranslates = locale.translation.Pages.App.Layout.Footer;
        const isAdmin = this.handleRoles();

        return (
            <div id="footer-bar" className="footer-bar-5 safe-area-view-bottom">
                <Link to={`/app/home`} className="active-nav">
                    {this.handleIcon('home', here)}
                    <span>{pageTranslates.Menu.Main}</span>
                    {here.toLowerCase() == 'home' && <strong className='bg-primary'></strong>}
                </Link>
                {/*<Link to={`${match.url}/cart`} className="active-nav">
                    {this.handleIcon('cart', here)}
                    <span>سبد خرید</span>
                    {here == 'cart' && <strong className='bg-primary'></strong>}
                </Link>*/}
                <Link to={`/app/account`} className="active-nav">
                    {this.handleIcon('account', here)}
                    <span>{pageTranslates.Menu.Profile}</span>
                    {here.toLowerCase() == 'account' && <strong className='bg-primary'></strong>}
                </Link>
                {isAdmin &&
                <Link to={`/app/admin/main`} className="active-nav">
                    {this.handleIcon('admin', here)}
                    <span>{pageTranslates.Menu.Admin}</span>
                    {here.toLowerCase() == 'admin' && <strong className='bg-primary'></strong>}
                </Link>
                }
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(withRouter(Footer));

